import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Policies.css";

export default function UsagePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="ijacna-policy-page-container">
      <header className="ijacna-policy-page-header">
        <h1>Usage Policy</h1>
        <p>
          IJACNA encourages responsible and ethical use of its published
          materials. Please read the following usage conditions carefully.
        </p>
      </header>

      <section className="ijacna-policy-section">
        <h2>Permitted Usage</h2>
        <ul>
          <li>
            Access and download materials for academic or research purposes.
          </li>
          <li>Share and cite IJACNA content with proper attribution.</li>
          <li>Use content for educational presentations and discussions.</li>
        </ul>
      </section>

      <section className="ijacna-policy-section alt-bg">
        <h2>Prohibited Usage</h2>
        <ul>
          <li>Reproduction, sale, or distribution without permission.</li>
          <li>Altering or misrepresenting IJACNA materials.</li>
          <li>Using content for commercial or unlawful purposes.</li>
        </ul>
      </section>

      <div className="ijacna-policy-back-button-container">
        <Link to="/policies" className="ijacna-policy-back-button">
          ← Back to Policies
        </Link>
      </div>
    </div>
  );
}
